<template>
    <NuxtLink
        :to="
            `${item.page_type === 'MODEL_RANGE' ? '/' + item.parent_slug : ''}` +
            `/${item.slug}`
        "
        class="!h-auto">
        <div
            class="group h-full overflow-hidden rounded-12 bg-[#FFFFFF0D] p-3 transition-colors duration-300">
            <div
                class="h-[14.75rem] w-full overflow-hidden rounded-12 bg-accent/10 transition-colors duration-150 md:group-hover:bg-accent/30">
                <picture>
                    <source
                        v-if="imageSrc.webp_url"
                        type="image/webp"
                        :srcset="getMediaLink(imageSrc.webp_url, 1000) || ''" />

                    <source
                        v-else-if="!imageSrc.url && !imageSrc.webp_url"
                        type="image/webp"
                        srcset="
                            /assets/images/ui/placeholder/webp/cromi.webp
                        " />

                    <img
                        loading="lazy"
                        :width="imageSrc.width || 416"
                        :height="imageSrc.width || 234"
                        :alt="props.item.image?.[0]?.alt || 'нет изображения'"
                        :src="
                            getMediaLink(imageSrc.url, 1000) ||
                            '/assets/images/ui/placeholder/jpg-png/cromi.png'
                        "
                        :class="{
                            'opacity-70 md:group-hover:opacity-100':
                                !item.image,
                        }"
                        class="size-full object-contain transition-all duration-500 md:group-hover:scale-110" />
                </picture>
            </div>
            <div class="mt-2 md:mt-3">
                <h3
                    v-html="productName"
                    class="text-20/120 font-semibold text-ash-200 transition-colors duration-500 lg:text-24/133" />
                <div
                    v-html="productDescription"
                    class="tinyeditor mt-2 line-clamp-6 text-16/150 font-medium text-accent-100 md:mt-5" />
            </div>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
import type { InterestingSectionCard } from '~/components/particles/product-line-interesting-section/product-line-interesting-section.types'

const props = defineProps({
    item: {
        type: Object as PropType<InterestingSectionCard>,
        required: true,
    },
})

const imageSrc = computed(() => {
    const images = {
        url: '',
        webp_url: '',
        width: 0,
        height: 0,
    }
    const image = props.item.image?.[0]

    if (image) {
        images.url = image.url
        images.webp_url = image.webp_url || ''
        images.width = image.width || 0
        images.height = image.height || 0
    }

    return images
})

const productName = computed(() => {
    if (props.item.model_range_name) return props.item.model_range_name
    return props.item.name
})
const productDescription = computed(() => {
    if (props.item.description_for_directions)
        return props.item.description_for_directions
    return props.item.description
})
</script>
